import type { BaseError } from '@/modules/errors/constants/error-class-map.gen';
import logger from '@/modules/logger/constants/logger';

/**
 * Handle a wretch fetch error
 * @param error - The error to handle.
 * @param namespace - The namespace to log the error under.
 * @param FetchErrorClass - The class to check if the error is an instance of.
 */
export default function handleWretchFetchError(
  error: unknown,
  namespace: string,
  FetchErrorClass: new (originalError?: Error) => BaseError
) {
  if (!(error instanceof FetchErrorClass)) return;
  logger.error(namespace, error, {
    displayErrorName: FetchErrorClass.name,
  });
  throw error;
}
